import { Row, Col, Skeleton, Space, Divider } from "antd";

export const LoadSkeleton = () => {
	return (
		<Row align="middle" justify="center" className="content-row">
			<Col span={24} align="middle" justify="center">
				<Col xs={24} sm={24} md={22} lg={20} xl={20} xxl={14} align="left" className="content-item">
					<Space direction="vertical" style={{ width: "100%" }}>
						<Space size={30} direction="horizontal">
							<Skeleton.Image active={true} />
							<Space>
								<Skeleton.Button active={true} />
								<Skeleton.Avatar active={true} />
								<Skeleton.Input active={true} />
							</Space>
						</Space>
						<Divider />

						<Skeleton active={true} />
						<Skeleton active={true} />
						<Skeleton active={true} />
					</Space>
				</Col>
			</Col>
		</Row>
	);
};
